import { 
    COURSE_BEGIN,
    COURSE_SUCCESS,
    COURSE_FAILURE,
    COURSE_CLEAR,

    COURSE_FILTER_BEGIN,
    COURSE_FILTER_SUCCESS,
    COURSE_FILTER_FAILURE,
    COURSE_FILTER_CLEAR,

    COURSE_CATEGORYAVAILABLE_BEGIN,
    COURSE_CATEGORYAVAILABLE_SUCCESS,
    COURSE_CATEGORYAVAILABLE_FAILURE,
    COURSE_CATEGORYAVAILABLE_CLEAR,

    COURSE_CATEGORYAVAILABLE_APPROVE_BEGIN,
    COURSE_CATEGORYAVAILABLE_APPROVE_SUCCESS,
    COURSE_CATEGORYAVAILABLE_APPROVE_FAILURE,
    COURSE_CATEGORYAVAILABLE_APPROVE_CLEAR,

    COURSE_CATEGORY_BEGIN,
    COURSE_CATEGORY_SUCCESS,
    COURSE_CATEGORY_FAILURE,
    COURSE_CATEGORY_CLEAR,

    COURSE_CATEGORY_APPROVE_BEGIN,
    COURSE_CATEGORY_APPROVE_SUCCESS,
    COURSE_CATEGORY_APPROVE_FAILURE,
    COURSE_CATEGORY_APPROVE_CLEAR,

    COURSE_CLIENTPROCEDUREAVAILABLE_BEGIN,
    COURSE_CLIENTPROCEDUREAVAILABLE_SUCCESS, 
    COURSE_CLIENTPROCEDUREAVAILABLE_FAILURE, 
    COURSE_CLIENTPROCEDUREAVAILABLE_CLEAR,

    COURSE_CLIENTPROCEDURE_BEGIN,
    COURSE_CLIENTPROCEDURE_SUCCESS, 
    COURSE_CLIENTPROCEDURE_FAILURE,
    COURSE_CLIENTPROCEDURE_CLEAR, 

    COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_BEGIN,
    COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_SUCCESS,
    COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_FAILURE,
    COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_CLEAR,

    COURSE_HOMOLOGOUSPROCEDURE_BEGIN,
    COURSE_HOMOLOGOUSPROCEDURE_SUCCESS,
    COURSE_HOMOLOGOUSPROCEDURE_FAILURE,
    COURSE_HOMOLOGOUSPROCEDURE_CLEAR, 

    COURSE_TESTAVAILABLE_SUCCESS,
    COURSE_TESTAVAILABLE_BEGIN,
    COURSE_TESTAVAILABLE_FAILURE,
    COURSE_TESTAVAILABLE_CLEAR,

    COURSE_TEST_SUCCESS,
    COURSE_TEST_BEGIN,
    COURSE_TEST_FAILURE,
    COURSE_TEST_CLEAR,

    COURSE_WORKCYCLEAVAILABLE_SUCCESS,
    COURSE_WORKCYCLEAVAILABLE_BEGIN,
    COURSE_WORKCYCLEAVAILABLE_FAILURE,
    COURSE_WORKCYCLEAVAILABLE_CLEAR,
    
    COURSE_WORKCYCLE_SUCCESS,
    COURSE_WORKCYCLE_BEGIN,
    COURSE_WORKCYCLE_FAILURE,
    COURSE_WORKCYCLE_CLEAR
} from 'app/actions/CourseActions';

const initialState = {
	byId: {},
    allIds: [],
    filterData: [],
    allCourseCategoryAvailable: [],
    allCourseCategory: [],
    allCourseCategoryAvailableApprove: [],
    allCourseCategoryApprove: [],
    allCourseClientProcedureAvailable: [],
    allCourseClientProcedure: [],
    allCourseHomologousProcedureAvailable: [],
    allCourseHomologousProcedure: [],
    allCourseTestAvailable: [],
    allCourseWorkCycle: [],
    allCourseWorkCycleAvailable: [],
    allCourseTest: [],
    isLoading: false,
    isLoadingApprove: false,
    isLoadingClientProcedureAvailable: true,
    isLoadingHomologousProcedureAvailable: true,
};

export default function CourseReducer (state = initialState, action) {
	switch (action.type) {
        case COURSE_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case COURSE_SUCCESS: 
			let allIds = [...new Set(state.allIds.concat(action.payload.data.allIds))];
			let byId = {
				...state.byId,
				...action.payload.data.byId
			};
			return {
				...state,
				allIds,
				byId,
				isLoading: false,
            };
        case COURSE_CLEAR:
            return {
                ...state,
                byId: {},
                allIds: [],
                isLoading: false,
            }
        case COURSE_FAILURE: 
			return {
				...state,
				isLoading: false
            }
        case COURSE_FILTER_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COURSE_FILTER_SUCCESS:
            let filterData = [...new Set(state.filterData.concat(action.payload.filterData))];
            return {
                ...state,
                filterData,
                isLoading: false,
            };
        case COURSE_FILTER_CLEAR:
            return {
                ...state,
                filterData: [],
                isLoading: false,
            }
        case COURSE_FILTER_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case COURSE_CATEGORYAVAILABLE_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COURSE_CATEGORYAVAILABLE_SUCCESS:
            let allCourseCategoryAvailable = [...new Set(state.allCourseCategoryAvailable.concat(action.payload.data.all))];

            return {
                ...state,
                allCourseCategoryAvailable,
                isLoading: false,
            };
        case COURSE_CATEGORYAVAILABLE_CLEAR:
            let courseAvailable = action.payload !== undefined ? state.allCourseCategoryAvailable.filter(x => action.payload.includes(x.idCategory)) : [];
            return {
                ...state,
                allCourseCategoryAvailable: courseAvailable,
                isLoading: false,
            }

        //Approver available
        case COURSE_CATEGORYAVAILABLE_APPROVE_BEGIN:
            return {
                ...state,
                isLoadingApprove: true
            }
        case COURSE_CATEGORYAVAILABLE_APPROVE_SUCCESS:
            let allCourseCategoryAvailableApprove = [...new Set(state.allCourseCategoryAvailableApprove.concat(action.payload.data.all))];
            
            return {
                ...state,
                allCourseCategoryAvailableApprove,
                isLoadingApprove: false,
            };
        case COURSE_CATEGORYAVAILABLE_APPROVE_CLEAR:
            let course = action.payload !== undefined ? state.allCourseCategoryAvailableApprove.filter(x => action.payload.includes(x.idCategory)) : [];
            
            return {
                ...state,
                allCourseCategoryAvailableApprove: course,
                isLoadingApprove: false,
            }
        case COURSE_CATEGORYAVAILABLE_APPROVE_FAILURE:
            return {
                ...state,
                isLoadingApprove: false
            }
            
        case COURSE_CATEGORY_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COURSE_CATEGORY_SUCCESS:
            let allCourseCategory = [...new Set(state.allCourseCategory.concat(action.payload.data.all))];

            return {
                ...state,
                allCourseCategory,
                isLoading: false,
            };
        case COURSE_CATEGORY_CLEAR:
            return {
                ...state,
                allCourseCategory: [],
                isLoading: false,
            }
        case COURSE_CATEGORY_FAILURE:
            return {
                ...state,
                isLoading: false
            }

        //Approver
        case COURSE_CATEGORY_APPROVE_BEGIN:
            return {
                ...state,
                isLoadingApprove: true
            }
        case COURSE_CATEGORY_APPROVE_SUCCESS:
            let allCourseCategoryApprove = [...new Set(state.allCourseCategoryApprove.concat(action.payload.data.all))];

            return {
                ...state,
                allCourseCategoryApprove,
                isLoadingApprove: false,
            };
        case COURSE_CATEGORY_APPROVE_CLEAR:
            return {
                ...state,
                allCourseCategoryApprove: [],
                isLoadingApprove: false,
            }
        case COURSE_CATEGORY_APPROVE_FAILURE:
            return {
                ...state,
                isLoadingApprove: false
            }

        case COURSE_CLIENTPROCEDUREAVAILABLE_BEGIN:
            return {
                ...state,
                isLoadingClientProcedureAvailable : true
            }
        case COURSE_CLIENTPROCEDUREAVAILABLE_SUCCESS:
            let allCourseClientProcedureAvailable = [...new Set(state.allCourseClientProcedureAvailable.concat(action.payload.data.all))];

            return {
                ...state,
                allCourseClientProcedureAvailable,
                isLoadingClientProcedureAvailable: false,
            };
        case COURSE_CLIENTPROCEDUREAVAILABLE_CLEAR:
            return {
                ...state,
                allCourseClientProcedureAvailable: [],
                isLoadingClientProcedureAvailable: false,
            }
        case COURSE_CLIENTPROCEDUREAVAILABLE_FAILURE:
            return {
                ...state,
                isLoadingClientProcedureAvailable: false
            }
        case COURSE_CLIENTPROCEDURE_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COURSE_CLIENTPROCEDURE_SUCCESS:
            let allCourseClientProcedure = [...new Set(state.allCourseClientProcedure.concat(action.payload.data.all))];

            return {
                ...state,
                allCourseClientProcedure,
                isLoading: false,
            };
        case COURSE_CLIENTPROCEDURE_CLEAR:
            return {
                ...state,
                allCourseClientProcedure: [],
                isLoading: false,
            }
        case COURSE_CLIENTPROCEDURE_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_BEGIN:
            return {
                ...state,
                isLoadingHomologousProcedureAvailable: true
            }
        case COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_SUCCESS:
            let allCourseHomologousProcedureAvailable = [...new Set(state.allCourseHomologousProcedureAvailable.concat(action.payload.data.all))];

            return {
                ...state,
                allCourseHomologousProcedureAvailable,
                isLoadingHomologousProcedureAvailable: false,
            };
        case COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_CLEAR:
            return {
                ...state,
                allCourseHomologousProcedureAvailable: [],
                isLoadingHomologousProcedureAvailable: false,
            }
        case COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_FAILURE:
            return {
                ...state,
                isLoadingHomologousProcedureAvailable: false
            }
        case COURSE_HOMOLOGOUSPROCEDURE_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COURSE_HOMOLOGOUSPROCEDURE_SUCCESS:
            let allCourseHomologousProcedure = [...new Set(state.allCourseHomologousProcedure.concat(action.payload.data.all))];

            return {
                ...state,
                allCourseHomologousProcedure,
                isLoading: false,
            };
        case COURSE_HOMOLOGOUSPROCEDURE_CLEAR:
            return {
                ...state,
                allCourseHomologousProcedure: [],
                isLoading: false,
            }
        case COURSE_HOMOLOGOUSPROCEDURE_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case COURSE_TESTAVAILABLE_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COURSE_TESTAVAILABLE_SUCCESS:
            let allCourseTestAvailable = action.payload.data.all;

            return {
                ...state,
                allCourseTestAvailable,
                isLoading: false,
            };
        case COURSE_TESTAVAILABLE_CLEAR:
            return {
                ...state,
                allCourseTestAvailable: [],
                isLoading: false,
            }
        case COURSE_TESTAVAILABLE_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case COURSE_TEST_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COURSE_TEST_SUCCESS:
            let allCourseTest = [...new Set(state.allCourseTest.concat(action.payload.data.all))];

            return {
                ...state,
                allCourseTest,
                isLoading: false,
            };
        case COURSE_TEST_CLEAR:
            return {
                ...state,
                allCourseTest: [],
                isLoading: false,
            }
        case COURSE_TEST_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case COURSE_WORKCYCLEAVAILABLE_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COURSE_WORKCYCLEAVAILABLE_SUCCESS:
            let allCourseWorkCycleAvailable = [...new Set(state.allCourseWorkCycleAvailable.concat(action.payload.data.all))];

            return {
                ...state,
                allCourseWorkCycleAvailable,
                isLoading: false,
            };
        case COURSE_WORKCYCLEAVAILABLE_CLEAR:
            return {
                ...state,
                allCourseWorkCycleAvailable: [],
                isLoading: false,
            }
        case COURSE_WORKCYCLEAVAILABLE_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case COURSE_WORKCYCLE_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COURSE_WORKCYCLE_SUCCESS:
            let allCourseWorkCycle = [...new Set(state.allCourseWorkCycle.concat(action.payload.data.all))];

            return {
                ...state,
                allCourseWorkCycle,
                isLoading: false,
            };
        case COURSE_WORKCYCLE_CLEAR:
            return {
                ...state,
                allCourseWorkCycle: [],
                isLoading: false,
            }
        case COURSE_WORKCYCLE_FAILURE:
            return {
                ...state,
                isLoading: false
            }
		default:
			return state;
	}

};

export const getCourse = state => {
	return state.allIds.map( id => state.byId[id] );
}

export const getIsLoadingCourse = state => {
    return state.isLoading;
}

export const getCourseFilter = state => {
    return state.filterData;
}

export const getIsLoadingCourseFilter = state => {
    return state.isLoading;
}

export const getCourseCategoryAvailable = state => {
    return state.allCourseCategoryAvailable;
}

export const getIsLoadingCourseCategoryAvailable = state => {
    return state.isLoading;
}


export const getCourseCategory = state => {
    return state.allCourseCategory;
}

export const getIsLoadingCourseCategory = state => {
    return state.isLoading;
}


export const getCourseClientProcedureAvailable = state => {
    return state.allCourseClientProcedureAvailable;
}

export const getIsLoadingCourseClientProcedureAvailable = state => {
    return state.isLoadingClientProcedureAvailable;
}


export const getCourseClientProcedure = state => {
    return state.allCourseClientProcedure;
}

export const getIsLoadingCourseClientProcedure = state => {
    return state.isLoading;
}

export const getCourseHomologousProcedureAvailable = state => {
    return state.allCourseHomologousProcedureAvailable;
}

export const getIsLoadingCourseHomologousProcedureAvailable = state => {
    return state.isLoadingHomologousProcedureAvailable;
}


export const getCourseHomologousProcedure = state => {
    return state.allCourseHomologousProcedure;
}

export const getIsLoadingCourseHomologousProcedure = state => {
    return state.isLoading;
}

export const getCourseTestAvailable = state => {
    return state.allCourseTestAvailable;
}

export const getIsLoadingCourseTestAvailable = state => {
    return state.isLoading;
}
export const getCourseTest = state => {
    return state.allCourseTest;
}

export const getIsLoadingCourseTest = state => {
    return state.isLoading;
}

export const getCourseWorkCycleAvailable = state => {
    return state.allCourseWorkCycleAvailable;
}

export const getIsLoadingCourseWorkCycleAvailable = state => {
    return state.isLoading;
}
export const getCourseWorkCycle = state => {
    return state.allCourseWorkCycle;
}

export const getIsLoadingCourseWorkCycle = state => {
    return state.isLoading;
}

